/**
 * Provide convenient API for application.
 * Use abstract data provider for data retrieving and handle it for application purposes.
 *
 * @module app.api.provider
 */

'use strict';


module.exports = function ( config, callback ) {
    var dataProvider = require('./data.provider'),
        api = {
            /**
             * Return a handled list of karaoke tracks for app.
             *
             * @param {Object} queryStringSet - set of name-value GET parameters
             * @param {Function} getTracksCallback - callback function
             */
            getTracks: function ( queryStringSet, getTracksCallback ) {
                dataProvider.getTracks(queryStringSet, function ( error, result ) {
                    var tracks;

                    if ( error ) {
                        getTracksCallback({message: 'Bad request error!'});
                    } else {
                        try {
                            if ( Array.isArray(result.data) ) {
                                tracks = result.data.map(function ( item ) {
                                    return {
                                        performer: item.performer,
                                        name:      item.name,
                                        url:       item.url,
                                        solution:  item.solution,
                                        id:        item.id,
                                        favorite:  item.favorite
                                    };
                                });

                                getTracksCallback(null, tracks);
                            } else {
                                getTracksCallback({message: 'Parse result error!'});
                            }
                        } catch ( error ) {
                            getTracksCallback({message: 'Parse result error!'});
                        }
                    }
                });
            },

            /**
             * Return URL for playback.
             *
             * @param {number} trackID - ID of karaoke track
             * @param {Function} getPlaybackLinkCallback - callback function
             */
            getPlaybackLink: function ( trackID, getPlaybackLinkCallback ) {
                dataProvider.getPlaybackLink(trackID, getPlaybackLinkCallback);
            },

            /**
             * Add or delete track from favorites list.
             *
             * @param {number} trackID - ID of the karaoke track
             * @param {boolean} favoriteState - favorites flag
             * @param {Function} setFavoriteStateCallback - callback function
             */
            setFavoriteState: function ( trackID, favoriteState, setFavoriteStateCallback ) {
                dataProvider.setFavoriteState(trackID, JSON.stringify({favorite: favoriteState}), setFavoriteStateCallback);
            }
        };

    callback(null, api);
};
